import React, { useEffect, useState } from 'react'
import farnell from "src/assets/images/farnell.png";
import { useProductInventoryStore } from 'src/hooks/productInventory';
import PriceTableForFarnell from '../Cart/PriceTableForFarnell';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag';

const FarnellInventoryStockPopup = (props) => {
    const { SetStatus, data } = props;
    const [{ }, { fetch_farnell_inventory_detail }, { }] = useProductInventoryStore();
    const [__check] = useAxiosIndicatorCheck();
    const [loader, setLoader] = useState(true)
    const [farnellData, setFarnellData] = useState([]);

    useEffect(() => {
        async function fetchHere() {
            let res = await fetch_farnell_inventory_detail({ ERPPartNumber: data.ERPPartNumber })
            if (res?.length > 0) {
                setFarnellData(res)
            }
            setLoader(false);
        }
        fetchHere();
    }, []);
    return (
        <div>
            <div className="avnet-modal modal-700">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center">
                        <h2 className="pcn-modal-heading font-24">
                            Available from Farnell (an Avnet Company)
                        </h2>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className='row'>
                            <div className='col-md-12 text-center'>
                                <p className='mb-2'>Check below for availability</p>
                                <img src={farnell} className='img-fluid' />
                            </div>
                            <div className='col-md-12 mb-3'>
                                {loader ? <AxiosIndicatorRunTimeLoader /> :
                                    (farnellData?.length > 0 &&
                                        <table className="bs5 table table-bordered mt-4">
                                            <thead>
                                                <tr className='bg-grey2'>
                                                    <th>PART NUMBER</th>
                                                    <th>PRICE</th>
                                                    <th>AVAILABILITY</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {farnellData?.map((x) => (
                                                    <tr>
                                                        <td><a href={`https://export.farnell.com/${x?.Sku}?cmp=EU-Avnet-PDP-cross-sell`} className="text-blue cursor-pointer" target='_blank'><b>{x?.TranslatedManufacturerPartNumber}</b></a></td>
                                                        <td><PriceTableForFarnell
                                                            single_product_pricing_list={x?.Prices} /></td>
                                                        <td> <div className=''>
                                                            <div className='d-flex justify-content-between'>
                                                                <div className='additional-title'>Partner Stock</div>
                                                                <div className='lead-time-digit text-end ms-1'>
                                                                    {x?.Stock?.Level}
                                                                </div>
                                                            </div>
                                                            {x?.Stock?.ShipsInDays}
                                                        </div></td>
                                                    </tr>
                                                ))
                                                }

                                            </tbody>
                                        </table>)
                                }
                                {farnellData?.length < 1 && !loader && <div className='mt-3'><AlertContentWithFlag message={'Due to API connectivity issue we are not able to fetch data'} type="danger" isDisplay={false} isDisplayIcon={true} addUsercontainer={true} /></div>}
                                {farnellData?.length > 0 && <p className='mt-3 d-block mb-0'>Farnell Terms and Conditions apply</p>}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                                cancel
                            </button>
                            <a href={`https://export.farnell.com/search?st=${farnellData?.length > 0 && farnellData[0]?.TranslatedManufacturerPartNumber}`} className={`bs5 btn btn-primary btn-sm w145 cursor-pointer ${!farnellData?.length ? ' disabled' : ''}`} target='_blank'>View on Farnell</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FarnellInventoryStockPopup
